import {
  PROTOTYPE_STENCIL_SLUG,
  TOP_SIDE,
  STENCIL_TOP_SIDE,
  STENCIL_BOTTOM_SIDE,
  basicStencils,
 } from "./StencilsConstants";

const state = {
  stencils: [],
  stencilsType: null,
  stencilsSide: null,
  stencilsParameters: {},
  stencilsToDestroy: [],
  stencilsToBuy: [],
}

if (Spree.stencils
  && Spree.stencils.length > 0
  && Spree.stencils_info
  && Spree.stencils_info.length > 0) {
  Spree.stencils.sort((a, b) => {
    const sideA = a.parameters.stencil_side;
    const sideB = b.parameters.stencil_side;
    if (sideA === sideB) return 0;
    if (sideA === STENCIL_TOP_SIDE) return -1;
    if (sideB === STENCIL_TOP_SIDE) return 1;
    if (sideA === STENCIL_BOTTOM_SIDE) return 1;
    if (sideB === STENCIL_BOTTOM_SIDE) return -1;
    return 0;
  }).forEach((initialStencilData) => {
    const product = Spree.stencils_info.find((p) => p.id === initialStencilData.product_id);
    const variant = product.variants.find((v) => v.id === initialStencilData.variant_id);
    const stencil = {
      product,
      variant,
      quantity: 1,
      parameters: initialStencilData.parameters,
      line_item_id: initialStencilData.line_item_id,
    };
    variant.option_values.forEach((optionValue) => {
      stencil.parameters[optionValue.option_type_name] = optionValue.name;
    });
    state.stencils.push(stencil);
    state.stencilsToBuy.push(_.cloneDeep(stencil));
  })

  // extract global parameters from first stencil
  state.stencilsType = state.stencils[0].product.slug;
  if (Spree.stencils.length > 1) {
    state.stencilsSide = 'both';
  } else {
    const prmSide = state.stencils[0].parameters.stencil_side;
    if (prmSide.split(' ')[0].includes('Top')) {
      state.stencilsSide = 'top';
    } else if (prmSide.split(' ')[0].includes('Bottom')) {
      state.stencilsSide = 'bottom';
    } else {
      state.stencilsSide = 'combined';
    }
  }

  state.stencilsParameters.panelize = state.stencils[0].parameters.panelize;
  state.stencilsParameters.print_confirmation = state.stencils[0].parameters.print_confirmation;
  state.stencilsParameters.special_instructions = state.stencils[0].parameters.special_instructions;
} else {
  state.stencilsType = PROTOTYPE_STENCIL_SLUG;
  state.stencilsSide = TOP_SIDE;

  let stencil = _.cloneDeep(basicStencils)
  stencil.product = Spree.stencils_info.find((s) => s.slug === PROTOTYPE_STENCIL_SLUG);
  stencil.parameters.stencil_side = STENCIL_TOP_SIDE;
  state.stencils.push(stencil);
}

export default state;
